import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { FAQ_PATH } from '../lib/faqLinks';

/**
 * The one line a page carries about its questions: «¿Dudas? Preguntas frecuentes →», to its topic
 * on /preguntas-frecuentes. The answers live there, once, instead of in a list on every page.
 */
export default function FaqLink({ topic, className = '' }) {
  return (
    <p className={`text-center text-sm text-slate-500 ${className}`} data-testid="faq-link">
      <Link to={`${FAQ_PATH}#${topic}`}
        className="inline-flex items-center gap-1.5 min-h-[44px] px-2 font-semibold text-slate-500 hover:text-torre-teal transition-colors">
        <HelpCircle size={15} aria-hidden="true" />
        ¿Dudas? <span className="text-torre-teal font-bold">Preguntas frecuentes →</span>
      </Link>
    </p>
  );
}
